import React from 'react'
import {Icon} from '@chakra-ui/react'

const BurgerIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M13 9.75C13.4142 9.75 13.75 10.0858 13.75 10.5C13.75 10.9142 13.4142 11.25 13 11.25H3C2.58579 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 2.58579 9.75 3 9.75H13ZM13 4.75C13.4142 4.75 13.75 5.08579 13.75 5.5C13.75 5.91421 13.4142 6.25 13 6.25H3C2.58579 6.25 2.25 5.91421 2.25 5.5C2.25 5.08579 2.58579 4.75 3 4.75H13Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default BurgerIcon
